// extracted by mini-css-extract-plugin
export default {"loadingContainer":"HomePage_loadingContainer__jLqnW"};